import React from "react";
import { Card } from "../../components/card";
import Renderer from "../../components/renderer";
import { useQuiz } from "./hooks";
import {
  getOptionValuesFromAnswer,
  getAnswerFromSelected,
  getAnswerKeyfromQuestion,
  getScoreForAnswer,
  getMarks,
} from "../../utils";

import Overview from "../../components/results/OverView";
import CorrectAnswer from "../../components/results/CorrectAnswer";
import Answer from "../../components/results/Answer";
import MatchTheFollowing from "../../components/quiz/MatchTheFollowing";
import { evaluateMTF } from "../../utils";
import { QuizResultAction } from "../../components/quiz/QuizResultAction";
import { ScreenTypes } from "../../store/quiz/quizSlice";
import { Grid } from "@mui/material";

export default function ResultScreen({
  onComplete,
  mandatePassing,
  onFail,
  onNavigateBack,
}) {
  const { result, setScreen, evaluationResult } = useQuiz();

  const handleOnComplete = () => {
    if (onComplete && typeof onComplete == "function") {
      onComplete();
    }

    setScreen(ScreenTypes.QuizDetail);
  };

  return (
    <Card style={styles.container} className="result-container">
      <div style={styles.innerContainer} className="result-inner-container">
        <Overview result={result} onNavigateBack={onNavigateBack} />
        {(evaluationResult?.evaluationDetails || []).map(
          (resultObject, index) => {
            const {
              evaluation = [],
              type,
              questionDetails = {},
              questionBankId,
              score: evaluationScore,
              maxScore,
            } = resultObject || {};
            const answerLabels = evaluation.length
              ? evaluation[0]["answerLabels"]
              : [];

            return (
              <div key={index} style={styles.questionContainer}>
                <div style={{ width: "90%" }}>
                  <div style={styles.questionInnerContainer}>
                    <h6 style={styles.questionNumber}>{`${index + 1}. `}</h6>
                    {/* <span style={styles.question}>{questionDetails.text}</span> */}
                    <Renderer
                      content={questionDetails.text}
                      mediaStyle={{ height: "150px", width: "150px" }}
                      style={{
                        width: "90%",
                        fontSize: "18px",
                        fontWeight: 600,
                        ...(type == "FIB"
                          ? { justifyContent: "start" }
                          : {
                              justifyContent: "start",
                              alignItems: "start",
                            }),
                      }}
                      contentUrl={questionDetails.contentURL}
                      contentType={questionDetails.style}
                      overrideHTML={questionDetails.overrideHTML}
                      contentDisplayType={type}
                      disabled={true}
                      templateType={questionDetails.displayTemplate}
                    />
                  </div>
                  <div>
                    <Grid
                      container
                      justifyContent={"start"}
                      alignItems={"center"}
                    >
                      {/* Handling the MSQs and MCQs here */}
                      {evaluation &&
                      evaluation.length &&
                      type != "MTF" &&
                      type != "FIB" ? (
                        evaluation.map((ans, index) => {
                          let { correct, wrong } = ans;
                          return (
                            <Grid item xs={10}>
                              <Answer
                                className="grid-item"
                                key={ans.label}
                                label={ans.label}
                                data={ans}
                                content={ans.value?.text}
                                wrong={wrong}
                                correct={correct}
                              />
                            </Grid>
                          );
                        })
                      ) : (
                        <React.Fragment>
                          {evaluation.map((_evaluation, i) => {
                            if (type == "MTF") {
                              let { left, right, answer } = _evaluation;

                              return (
                                <MatchTheFollowing
                                  key={i + 1}
                                  disabled={true}
                                  mode={"result"}
                                  questionId={questionBankId}
                                  selectedAnswer={answer}
                                  left={left}
                                  right={right}
                                  enableTextToAudio={false}
                                  evaluated={true}
                                />
                              );
                            }

                            // Handle  FIB
                            let { correct, wrong, fibValue } = _evaluation;

                            return (
                              <Grid item xs={10}>
                                <Answer
                                  className="grid-item"
                                  key={i}
                                  data={fibValue}
                                  content={(Array.isArray(fibValue)
                                    ? fibValue
                                    : []
                                  ).join("")}
                                  wrong={wrong}
                                  correct={correct}
                                />
                              </Grid>
                            );
                          })}
                        </React.Fragment>
                      )}
                    </Grid>
                    {/* only show if the answer is wrong and not MTF */}
                    {(!evaluationScore ||
                      ((type == "MSQ" || type == "FIB") &&
                        evaluationScore < maxScore)) &&
                      type != "MTF" && (
                        <CorrectAnswer
                          answerLabels={answerLabels}
                          type={type}
                          choices={evaluation}
                        />
                      )}
                  </div>
                </div>
                <div style={styles.scoreContainer}>
                  <span
                    style={styles.score}
                    className={
                      "scores " +
                      (evaluationScore ? "color-success" : "color-wrong")
                    }
                  >
                    {evaluationScore}
                  </span>
                </div>
              </div>
            );
          },
        )}
      </div>
      <div style={styles.retryContainer}>
        <QuizResultAction
          onFail={onFail}
          mandatePassing={mandatePassing}
          onComplete={handleOnComplete}
        />
      </div>
    </Card>
  );
}

const styles = {
  container: {
    border: "none",
    padding: "0px",
  },
  innerContainer: {
    background: "var(--color-white)",
    borderRadius: "4px",
    margin: "0 auto",
    padding: "0 0 40px",
    overflow: "scroll",
    height: "100vh",
    // height: 'calc(100vh - 150px)'
  },
  questionContainer: {
    display: "flex",
    justifyContent: "start",
    alignItems: "start",
    marginTop: "40px",
    padding: "0px 40px",
  },
  questionInnerContainer: {
    display: "flex",
    marginBottom: "6px",
  },
  questionNumber: {
    fontSize: "18px",
    fontWeight: 600,
    margin: 0,
    marginRight: "18px",
    color: "var(--color-black)",
  },
  question: {
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: 1.3,
    color: "var(--color-black)",
    marginBottom: "20px",
  },
  renderer: {
    width: "90%",
    marginBottom: "40px",
    paddingLeft: "40px",
  },
  scoreContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "70px",
    width: "70px",
    borderRadius: "50%",
    border: "2px solid rgba(255, 122, 0, 1)",
  },
  score: {
    fontWeight: 700,
    fontSize: "18px",
    margin: "0px",
    textAlign: "center",
  },
  retryContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "40px",
  },
};
